import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  userName = '';
  companyName = '';
  companyLogo = '';
  email = '';

  ngOnInit(): void {
    const raw = localStorage.getItem('currentUser');
    const user = raw ? this.safeJsonParse(raw) : {};
    this.userName = user?.name || user?.email || 'there';
    this.email = user?.email || localStorage.getItem('EmailId') || '';
    this.companyName = localStorage.getItem('CompanyName') || '';
    this.companyLogo = localStorage.getItem('CompanyLogo') || '';
  }

  constructor(private readonly router: Router) { }

  logout(): void {
    // Mirrors the keys Login.ts writes (Login.ts:146-157) — clears the whole session, not just the
    // token, since nothing in this file set exposes a dedicated "clear session" helper to reuse.
    [
      'accessToken', 'token', 'refreshToken', 'user', 'currentUser', 'currentClient',
      'currentProduct', 'CurrentProductUId', 'CurrentClientUId', 'CurrentRoleBasedlogedin',
      'CurrentloggedInUId', 'CurrentDeviceID', 'EmailId', 'CompanyName', 'CompanyLogo',
    ].forEach(k => localStorage.removeItem(k));
    this.router.navigate(['/login']);
  }

  private safeJsonParse(value: string): any {
    try { return JSON.parse(value); } catch { return {}; }
  }
}
